var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_282_11201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0612 23.9387C30.343 24.2205 30.5013 24.6027 30.5013 25.0012C30.5013 25.3997 30.343 25.7819 30.0612 26.0637C29.7794 26.3455 29.3972 26.5038 28.9987 26.5038C28.6002 26.5038 28.218 26.3455 27.9362 26.0637L19.9999 18.125L12.0612 26.0612C11.7794 26.343 11.3972 26.5013 10.9987 26.5013C10.6002 26.5013 10.218 26.343 9.9362 26.0612C9.6544 25.7794 9.49609 25.3972 9.49609 24.9987C9.49609 24.6002 9.6544 24.218 9.9362 23.9362L17.8749 16L9.9387 8.06122C9.6569 7.77943 9.49859 7.39724 9.49859 6.99872C9.49859 6.60021 9.6569 6.21802 9.9387 5.93622C10.2205 5.65443 10.6027 5.49612 11.0012 5.49612C11.3997 5.49612 11.7819 5.65443 12.0637 5.93622L19.9999 13.875L27.9387 5.93497C28.2205 5.65318 28.6027 5.49487 29.0012 5.49487C29.3997 5.49487 29.7819 5.65318 30.0637 5.93497C30.3455 6.21677 30.5038 6.59896 30.5038 6.99747C30.5038 7.39599 30.3455 7.77818 30.0637 8.05998L22.1249 16L30.0612 23.9387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_282_11201",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_282_11201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_282_11201",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.89110629e6360c9e301a5a62372d044d.svg";
export { ForwardRef as ReactComponent };